/**
 * Mapping der tenantspezifischen Tabellen-Farbschema-Schluessel (Branding `tableScheme`) auf die
 * CSS-Custom-Properties aus `styles/tableScheme.css`. Einzige Quelle fuer Whitelist und Variablennamen.
 */
export const TABLE_SCHEME_VARIABLES = Object.freeze({
  headerBg: '--mv-table-header-bg',
  headerBorder: '--mv-table-header-border',
  rowHoverBg: '--mv-row-hover-bg',
  rowSelectedBg: '--mv-row-selected-bg',
  rowSelectedHoverBg: '--mv-row-selected-hover-bg',
  creditRowBg: '--mv-credit-row-bg',
  focusRing: '--mv-focus-ring',
  panelHeaderBg: '--mv-panel-header-bg',
  panelBorder: '--mv-panel-border',
  saldoRowBg: '--mv-saldo-row-bg'
});

/** Erlaubtes Farbformat (identisch zur serverseitigen Validierung): #rrggbb. */
export const TABLE_SCHEME_HEX_PATTERN = /^#[0-9a-f]{6}$/i;
